import VVSFormDesign from "components/Common/VVSFormDesign";
import React from "react";
import { Container } from "reactstrap";

const FormDesign = () => {
  return (
    <div className="page-content">
      <Container fluid>
        <VVSFormDesign />
      </Container>
    </div>
  );
};

export default FormDesign;
